import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms'

import { ConfigsBandeirasOperadora } from './configuracao-integracao-bandeira.component'

export class ConfiguracaoIntegracaoBandeiraValidators {
    static configuracaoExistente(
        configuracoes: ConfigsBandeirasOperadora[],
        operadoraControl: AbstractControl
    ): ValidatorFn {
        return (bandeiraControl: AbstractControl): ValidationErrors => {
            if (!(operadoraControl.value && bandeiraControl.value)) {
                return null
            }

            const configsOperadora = configuracoes.find(
                configsOp => configsOp.operadora.id === operadoraControl.value.id
            )

            if (configsOperadora) {
                const configExistente = configsOperadora.configuracoesBandeiras.find(
                    configBandeira =>
                        configBandeira.bandeira.id === bandeiraControl.value.id
                )

                if (configExistente) {
                    return { configuracaoExistente: configExistente }
                }
            }

            return null
        }
    }

    static atLeastOne(controls: AbstractControl[]): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            const someFulfilled = controls.some(c => !isEmptyValue(c.value))

            if (someFulfilled || !isEmptyValue(control.value)) {
                return null
            }
            return { atLeastOne: controls }
        }
    }
}

function isEmptyValue(value: any) {
    return value === undefined || value === null || value === ''
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-integracao-bandeira.validators.ts